import { middlewareInstructions } from './types'

export default function redirect(): middlewareInstructions {
  return { to: { name: 'subscription-portal-sign-in' }, actions: 'logout' }
}
